import { Outlet } from "react-router-dom";
import bottomGraphic from "../../assets/bottom-graphic.png";
import topGraphic from "../../assets/top-graphic.png";
import Sidebar from "../../components/sidebar/Sidebar";
import { ProfilePg } from "./styled";

const Personal = () => {
  return (
    <ProfilePg>
      <div className="content-container">
        <Sidebar />
        <Outlet />
      </div>
    </ProfilePg>
  );
};

export default Personal;
